export type NotificationTone = 'info' | 'danger' | 'warning' | 'success';

/** Círculo do ícone na lista de notificações. */
export const NOTIFICATION_TONE_ICON_CLASSES: Record<NotificationTone, string> =
  {
    success: 'bg-emerald-100 text-emerald-700',
    info: 'bg-sky-100 text-sky-700',
    warning: 'bg-amber-100 text-amber-700',
    danger: 'bg-red-100 text-red-700',
  };

/** Destaque inline no título (ex.: ID). */
export const NOTIFICATION_TONE_TEXT_CLASSES: Record<NotificationTone, string> =
  {
    success: 'text-emerald-600',
    info: 'text-sky-600',
    warning: 'text-amber-600',
    danger: 'text-red-600',
  };

/** Pill do contador no header do dropdown. */
export const NOTIFICATION_TONE_PILL_CLASSES: Record<NotificationTone, string> =
  {
    success: 'bg-emerald-50 text-emerald-700',
    info: 'bg-sky-50 text-sky-700',
    warning: 'bg-amber-50 text-amber-700',
    danger: 'bg-red-50 text-red-700',
  };

export function notificationIconToneClass(tone: NotificationTone): string {
  return NOTIFICATION_TONE_ICON_CLASSES[tone];
}

export function notificationTextToneClass(tone: NotificationTone): string {
  return NOTIFICATION_TONE_TEXT_CLASSES[tone];
}
